// Minimal carousel quick add.
// Single-variant products: the "+" is the form's submit button; <s-product-form> adds to cart and opens the drawer.
// Multi-variant products: the "+" toggles a small option panel over the bottom of the image; choosing an option
// writes its variant ID into the hidden input before the native submit, so <s-product-form> handles the add.
class SQuickAdd extends HTMLElement {
  #controller = null;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.toggleButton = this.querySelector('[data-quick-add-toggle]');
    this.panel = this.querySelector('[data-quick-add-panel]');
    this.input = this.querySelector('input[name="id"]');

    this.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-quick-add-toggle]');
      if (toggle) {
        event.preventDefault();
        this.setOpen(this.panel?.hidden ?? false);
        return;
      }
      const option = event.target.closest('[data-variant-id]');
      if (option && this.input) this.input.value = option.dataset.variantId;
    }, { signal });

    // Understated dropdown (cart "Wear it with"): mirror the chosen option into the visible label.
    this.addEventListener('change', (event) => {
      const select = event.target.closest('[data-variant-select]');
      if (!select) return;
      const label = select.parentElement?.querySelector('[data-selected-label]');
      const option = select.options[select.selectedIndex];
      if (label && option) label.textContent = option.textContent;
      // Show only the chosen option's price on the card.
      const price = select.closest('li')?.querySelector('[data-selected-price]');
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
    }, { signal });

    // Close the panel once the add starts; the cart drawer takes over from here.
    this.addEventListener('submit', () => requestAnimationFrame(() => this.setOpen(false)), { signal });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.panel && !this.panel.hidden) {
        this.setOpen(false);
        this.toggleButton?.focus();
      }
    }, { signal });

    document.addEventListener('click', (event) => {
      if (this.panel && !this.panel.hidden && !this.contains(event.target)) this.setOpen(false);
    }, { signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  setOpen(open) {
    if (!this.panel || !this.toggleButton) return;
    this.panel.hidden = !open;
    this.toggleButton.setAttribute('aria-expanded', String(open));
    if (open) this.panel.querySelector('button:not([disabled])')?.focus();
  }
}

if (!customElements.get('s-quick-add')) customElements.define('s-quick-add', SQuickAdd);
